import { FC, useEffect, useState } from 'react'
import { KTIcon } from '../../../../_metronic/helpers'
import { fetchData, formatNumber, toasterrormsg } from '../../../../reusable';
import { ToastContainer } from 'react-toastify';
import { PageTitle } from '../../../../_metronic/layout/core';
import { Link, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import moment from 'moment';
import { Tr } from '../../../../_metronic/i18n/Tr';

const ViewCarCouponList: FC = () => {

  const t = Tr()
  const navigate = useNavigate()
  const categoryId = sessionStorage.getItem('categoryId');
  useEffect(() => {
    if (categoryId != '7') {
      navigate('../dashboard/');
    }
  }, [categoryId])
  var vendorId = "";
  const vendorData = sessionStorage.getItem("vendor");
  if (vendorData) {
    var vendor = JSON.parse(vendorData);
    vendorId = vendor.vendorId;

  } else {
    console.log("No vendor data found");
  }
  const [offset, setoffset] = useState(0)
  const [limit, setlimit] = useState(9);
  const [page, setpage] = useState(1)
  const [totalPage, setTotalPage] = useState(1)
  const [from, setfrom] = useState(1)
  const [to, setTo] = useState(1)
  const [couponList, setCouponList] = useState([]);
  const [displayCouponList, setDisplayCouponList] = useState([]);
  const [pageNumbersList, setPageNumberList] = useState([1])

  // page number generater
  function generatePageNumbers(currentPage: any, totalPages: any, maxPagesToShow: any) {
    const halfMaxPages = Math.floor(maxPagesToShow / 2);
    let startPage = Math.max(1, currentPage - halfMaxPages);
    let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);

    // Adjust startPage and endPage if the total pages to show is less than maxPagesToShow
    if (endPage - startPage + 1 < maxPagesToShow) {
      startPage = Math.max(1, endPage - maxPagesToShow + 1);
    }

    // Generate the list of page numbers
    const pageNumbers = [];
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }

    return pageNumbers;
  }
  // on page change function
  const onpagecahnge = (pageId: any) => {
    if (pageId != page && pageId != 0 && pageId <= totalPage) {
      var tmp = (pageId - 1) * limit
      setpage(pageId)
      setoffset(tmp)
      setfrom(tmp + 1)
      // setto
      var mod = couponList.length % limit
      var tolimi: any = limit
      if (mod > 0) {
        if (mod <= limit) {
          tolimi = pageId * limit

        }
        else {
          tolimi = pageId * limit + limit
        }
      }
      else {
        tolimi = pageId * limit
      }
      setTo(tolimi)
      var tmpdata: any = couponList.slice(tmp, tolimi)
      setDisplayCouponList(tmpdata)
    }

  }
  const projectsearch=async(text:any)=>{
    
    if(text=="" || text==null || text==undefined)
    { 
      var tmp:any=couponList.slice(offset, offset+limit);
      
        setDisplayCouponList(tmp)
        
        var totpag=(Math.ceil(couponList.length/limit))
        setTotalPage(totpag)
        if(totpag==1)
        {
          var mod=couponList.length%limit
          if(mod>0)
          {
            setTo(mod)
          }
          else
          {
            setTo(tmp.length)
          }
        }
        else
        {
          var mod=couponList.length%limit
          
          if(mod>0)
          {
            if(mod<=limit)
            {
              setTo(page*limit)
              
            }
            else
            {
              setTo(page*limit+limit)
            }
          }
          else
          {
            setTo(page*limit)
          }
        }
        var genpag=generatePageNumbers(page,totpag,6)
        setPageNumberList(genpag) 
    }
    else
    {
      var tmp:any = couponList.filter((item:any) => {
        return (item.en_offertitle != null && item.en_offertitle != "" && (item.en_offertitle).toLowerCase().includes(text.toLowerCase())) ||
               (item.ru_offertitle != null && item.ru_offertitle != "" && (item.ru_offertitle).toLowerCase().includes(text.toLowerCase()) ||
               (item.uz_offertitle != null && item.uz_offertitle != "" && (item.uz_offertitle).toLowerCase().includes(text.toLowerCase()) ||
               (item.couponCode != null && item.couponCode != "" && (item.couponCode).toLowerCase().includes(text.toLowerCase()) ||
               (item.couponType != null && item.couponType != "" && (item.couponType).toLowerCase().includes(text.toLowerCase())))));
        });
      setDisplayCouponList(tmp)
    }
  }
  //   coupon list api call
  const couponListApiCall = async () => {
    var param = {
      'vendorId': String(vendorId),
      'categoryId': categoryId
    }
    var res = await fetchData("public/couponList", param)

    if (res.status == "200") {
      var data = res.data;
      setCouponList(data);
      var tmp: any = res.data.slice(offset, offset + limit);
      setDisplayCouponList(tmp)
      var totpag = (Math.ceil(res.data.length / limit))
      setTotalPage(totpag)
      if (totpag == 1) {
        var mod = res.data.length % limit
        if (mod > 0) {
          setTo(mod)
        }
        else {
          setTo(tmp.length)
        }
      }
      else {
        var mod = res.data.length % limit
        if (mod > 0) {
          setTo(page * limit + mod)
        }
        else {
          setTo(page * limit)
        }
      }

      var genpag = generatePageNumbers(page, totpag, 6)
      setPageNumberList(genpag)
    }
    else {
      toasterrormsg(res.message)
    }
  }

  //   delete hotel api call
  const confirmdelete = (id: any) => {
    Swal.fire({
      title: t('Are you sure?'),
      text: t('You Want To Delete'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: t('Yes'),
      cancelButtonText: t('No'),
    }).then(async (result) => {
      if (result.isConfirmed) {

        var param = {
          'couponId':String(id)
        }
        var res = await fetchData("public/couponDelete", param)
        if (res.status == "200") {
          couponListApiCall();
        }
        else {
          toasterrormsg(res.message)
        }
      }
    });
  }
  useEffect(() => {
    couponListApiCall();
  }, [])
  return (
    <>
      <ToastContainer />
      <PageTitle breadcrumbs={[]}>{t('Coupon Management List')}</PageTitle>
      <div className={`card mb-5 mb-xl-8`}>
        {/* begin::Header */}
        <div className='card-header border-0 pt-5'>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bold fs-3 mb-1'>{t('Coupon Management')}</span>
          </h3>
          <div className='card-toolbar'>
            <div className='d-flex align-items-center position-relative me-4'>
              <KTIcon iconName='magnifier' className='fs-3 position-absolute ms-3' />
              <input
                type='text'
                id='kt_filter_search'
                className='form-control form-control-white form-control-sm w-150px ps-9'
                placeholder={t('Search')}
                onChange={(e) => {projectsearch(e.target.value)}}
              />
            </div>
            <Link
              to='../addcarcoupon/'
              className='btn text-white cursor-pointer btn-light-primary'
              id='kt_toolbar_primary_button'
              style={{ color: 'rgb(24, 28, 50)' }}
            >
              + {t('Add Coupon')}
            </Link>
          </div>
        </div>
        {/* end::Header */}
        {/* begin::Body */}
        <div className='card-body py-3'>
          {/* begin::Table container */}
          <div className='table-responsive'>
            {/* begin::Table */}
            <table className='table align-middle gs-0 gy-4'>
              {/* begin::Table head */}
              <thead>
                <tr className='fw-bold text-muted bg-light'>
                  <th className='ps-4 min-w-350px rounded-start'>{t('Offer Title')}</th>
                  <th className='min-w-150px'>{t('Coupon Code')}</th>
                  <th className='min-w-250px'>{t('Period')}</th>
                  <th className='min-w-150px'>{t('Total Coupons')}</th>
                  <th className='min-w-150px'>{t('Coupon Value')}</th>
                  <th className='min-w-100px'>{t('Status')}</th>
                  <th className='min-w-100px text-end rounded-end pe-4'>{t('Action')}</th>
                </tr>
              </thead>
              {/* end::Table head */}
              {/* begin::Table body */}
              <tbody>
                {
                  displayCouponList.map((coupon:any,index:any) => {
                    var couponValue = "0";
                    if(coupon['couponType'] == 'FIXED'){
                      couponValue = formatNumber(coupon['couponValue'])+' UZS'
                    }else if(coupon['couponType'] == 'PERCENTAGE'){
                      couponValue = formatNumber(coupon['couponValue'])+'%'
                    }
                    return (
                      <tr key={index}>
                        <td>
                          <div className='d-flex align-items-center'>
                            <div className='symbol symbol-50px me-5'>
                              <img
                                src={coupon['image']}
                                alt='coupon-img'
                              />
                            </div>
                            <div className='d-flex justify-content-start flex-column'>
                              <h6 className='fw-bold mb-1 fs-6' style={{color:'black'}}>
                                {coupon['en_offertitle']}
                              </h6>
                            </div>
                          </div>
                        </td>
                        <td>
                        <div className='fw-bold mb-1 fs-6'>{coupon['couponCode']}</div>
                        </td>
                        <td>
                          <div className='fw-bold mb-1 fs-6'>{moment(coupon['from']).format('DD.MM.YYYY')} - {moment(coupon['to']).format('DD.MM.YYYY')}</div>
                        </td>
                        <td>
                          <div className='fw-bold mb-1 fs-6'>{coupon['limitPerCoupon']}</div>
                        </td>
                        <td>
                          <div className='fw-bold mb-1 fs-6'>{couponValue}</div>
                        </td>
                        <td>
                        {coupon['status'] == 0 && (<span className='badge badge-light-success fs-7 fw-semibold'>{t('Validate')}</span>)}
                        {coupon['status'] == 1 && (<span className='badge badge-light-danger fs-7 fw-semibold'>{t('Expired')}</span>)}
                        </td>
                        <td className='text-end'>
                          <Link
                            to='../addcarcoupon/'
                            state={{couponId:coupon['couponId']}}
                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                          >
                            <KTIcon iconName='pencil' className='fs-3' />
                          </Link>
                          <button className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm' onClick={() => confirmdelete(coupon['couponId'])}>
                            <KTIcon iconName='trash' className='fs-3' />
                          </button>
                        </td>
                      </tr>
                    )
                  })
                }
              </tbody>
              {/* end::Table body */}
            </table>
            {/* end::Table */}
          </div>
          {/* end::Table container */}
          {
            couponList.length != 0 ? (
              <div className='d-flex flex-stack flex-wrap pt-10'>
                <div className='fs-6 fw-bold text-gray-700'>Showing {from} to {to} of {couponList.length} entries</div>

                <ul className='pagination'>

                  <li className={`page-item previous ${page > 1 ? "" : "disabled"}`}>
                    <span className={`page-link ${page > 1 ? "cursor-pointer" : "disabled"}`} onClick={() => onpagecahnge(page - 1)}>
                      <i className='previous'></i>
                    </span>
                  </li>
                  {pageNumbersList.map((item: any, index: any) => {
                    return (
                      <li className={`page-item cursor-pointer ${page == item ? "active" : ""}`} key={index}>
                        <span className='page-link' onClick={() => onpagecahnge(item)}>
                          {item}
                        </span>
                      </li>
                    )
                  })}
                  <li className={`page-item next ${page + 1 <= totalPage ? "" : "disabled"}`}>
                    <span className={`page-link ${page + 1 <= totalPage ? "cursor-pointer" : "disabled"}`} onClick={() => page + 1 <= totalPage ? onpagecahnge(page + 1) : ""}>
                      <i className='next'></i>
                    </span>
                  </li>
                </ul>
              </div>
            ) : ('')
          }
        </div>
        {/* begin::Body */}
      </div>
    </>
  )
}

export { ViewCarCouponList }